import { Controller } from 'stimulus';

export default class extends Controller {
  uncheck(event) {
    if (this.#matchNameIfPresent(event) && this.checked === true) {
      this.element.checked = false;
      this.element.dispatchEvent(new Event('change'));
    }
  }

  get checked() {
    return this.element.checked;
  }

  get name() {
    return this.element.name;
  }

  #matchNameIfPresent({ detail }) {
    const hasName = detail.hasOwnProperty('name');

    return hasName ? detail.name === this.name : true;
  }
}
